import React, { useEffect, useState } from 'react';
import { Modal, notification } from 'antd';

const FilePreviewModal = ({ visible, onClose, url }) => {
    const [fileType, setFileType] = useState(null);

    useEffect(() => {
        if (!url) return;

        const lowerUrl = url.toLowerCase();

        if (lowerUrl.endsWith('.pdf')) {
            setFileType('pdf');
        } else if (lowerUrl.endsWith('.png') || lowerUrl.endsWith('.jpg') || lowerUrl.endsWith('.jpeg') || lowerUrl.endsWith('.webp')) {
            setFileType('image');
        } else {
            setFileType('unknown');
            notification.error({
                message: 'Unsupported File Type',
                description: 'Only PDF and image files (png, jpg, jpeg, webp) are supported.',
            });
        }
    }, [url]);

    const renderContent = () => {
        if (!url || fileType === 'unknown') {
            return <div style={{ textAlign: 'center', padding: '20px' }}>Cannot preview this file type.</div>;
        }

        if (fileType === 'pdf') {
            return (
                <iframe
                    src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(url)}`}
                    title="PDF Preview"
                    width="100%"
                    height="600px"
                    style={{ border: 'none' }}
                />
            );
        }

        if (fileType === 'image') {
            return (
                <img
                    src={url}
                    alt="Preview"
                    style={{ maxWidth: '100%', maxHeight: '600px', display: 'block', margin: '0 auto' }}
                />
            );
        }
    };

    return (
        <Modal
            visible={visible}
            onCancel={onClose}
            footer={null}
            width={800}
            destroyOnClose
            title="File Preview"
        >
            {renderContent()}
        </Modal>
    );
};

export default FilePreviewModal;
